var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcWalletRainbow = function SvgIcWalletRainbow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_wallet_rainbow_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0v20h20V0Z",
    fill: "url(#ic_wallet_rainbow_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 6.475h.825a7.7 7.7 0 0 1 7.7 7.7V15h1.65c.456 0 .825-.37.825-.825C16 8.555 11.445 4 5.825 4A.825.825 0 0 0 5 4.825v1.65Z",
    fill: "url(#ic_wallet_rainbow_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8 14.175H16c0 .456-.37.825-.825.825H13.8v-.825Z",
    fill: "url(#ic_wallet_rainbow_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.825 4v2.2H5V4.825C5 4.369 5.37 4 5.825 4Z",
    fill: "url(#ic_wallet_rainbow_svg__e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 6.2h.825a7.975 7.975 0 0 1 7.975 7.975V15h-2.475v-.825a5.5 5.5 0 0 0-5.5-5.5H5V6.2Z",
    fill: "url(#ic_wallet_rainbow_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6 14.175h2.2V15h-2.2v-.825Z",
    fill: "url(#ic_wallet_rainbow_svg__g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8.4V6.2h.825v2.2H5Z",
    fill: "url(#ic_wallet_rainbow_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 9.775c0 .455.37.825.825.825C7.8 10.6 9.4 12.2 9.4 14.175c0 .455.37.825.825.825H11.6v-.825A5.775 5.775 0 0 0 5.825 8.4H5v1.375Z",
    fill: "url(#ic_wallet_rainbow_svg__i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4 14.175h2.2V15h-1.375a.825.825 0 0 1-.825-.825Z",
    fill: "url(#ic_wallet_rainbow_svg__j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.825 10.6A.825.825 0 0 1 5 9.775V8.4h.825v2.2Z",
    fill: "url(#ic_wallet_rainbow_svg__k)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "ic_wallet_rainbow_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-90 10 4.175) scale(10.1749)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FF4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8754C9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ic_wallet_rainbow_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-90 10 4.175) scale(7.97494)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#FFF700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9901"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ic_wallet_rainbow_svg__i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-90 10 4.175) scale(5.77495)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DA40"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ic_wallet_rainbow_svg__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.33748 0 0 6.23328 9.263 14.588)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DA40"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ic_wallet_rainbow_svg__k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 -2.33748 44.3255 0 5.413 10.737)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DA40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic_wallet_rainbow_svg__b",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#174299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001E59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic_wallet_rainbow_svg__d",
    x1: 13.662,
    y1: 14.588,
    x2: 16,
    y2: 14.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8754C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic_wallet_rainbow_svg__e",
    x1: 5.413,
    y1: 4,
    x2: 5.413,
    y2: 6.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8754C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic_wallet_rainbow_svg__g",
    x1: 11.6,
    y1: 14.588,
    x2: 13.8,
    y2: 14.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic_wallet_rainbow_svg__h",
    x1: 5.413,
    y1: 8.4,
    x2: 5.413,
    y2: 6.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9901"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_wallet_rainbow_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#fff"
  })))));
};
export default SvgIcWalletRainbow;